// extracted by mini-css-extract-plugin
export var echartContent = "index-module--echartContent--92008";
export var echarts2 = "index-module--echarts2--e2f31";
export var million = "index-module--million--f6347";
export var title = "index-module--title--d72e0";
export var year = "index-module--year--dd83f";
export var year1 = "index-module--year1--0acd8";
export var year2 = "index-module--year2--df45b";
export var year3 = "index-module--year3--24e77";
export var year4 = "index-module--year4--cc60e";
export var year5 = "index-module--year5--44fbd";
export var year6 = "index-module--year6--235f0";